
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/pdf-tools/decrypt-pdf",
      function () {
        return require("private-next-pages/signature/pdf-tools/decrypt-pdf/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signature/pdf-tools/decrypt-pdf"])
      });
    }
  